module.exports = __webpack_public_path__ + "static/media/TW-GerardRoss-desktop-1220x1500@2x-80.71617b43.jpg";